module.exports = __webpack_public_path__ + "static/img/kh.5a13865d.svg";